import React, { useEffect } from 'react';
import PropTypes from "prop-types"
import { Tabs, Box, Tab } from "@mui/material"
import ProductTag from "@pages/ProductListing/view/components/ProductTag"

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    )
  }
  
  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  }
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    }
  }

function SearchResult({ data, allData, onPlaceSelect, setCategoryType, centerChangedFlag }) {
    // const eboStores = (data.filter(store => store.storeType === 'EBO')).sort((a, b) => a.rank - b.rank);
    // const mboStores = (data.filter(store => store.storeType === 'MBO')).sort((a, b) => a.rank - b.rank);
    const [eboStores, setEboStores] = React.useState([]);
    const [mboStores, setMboStores] = React.useState([]);

    const [tabValue, setTabValue] = React.useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        if(newValue === 0) {
            setCategoryType('FABRIC');
        } else if(newValue === 1) {
            setCategoryType('BEDDING');
        }
    };

    useEffect(() => {
        if (data.length > 0) {
            // setTabValue(0); // Reset to first tab when data changes
            if(tabValue === 0) {
                const tempData = data?.filter(store => store?.categoryType?.includes('FABRIC'));
                setEboStores(tempData.filter(store => store?.storeType === 'EBO').sort((a, b) => a?.distance - b?.distance));
                setMboStores(tempData.filter(store => store?.storeType === 'MBO').sort((a, b) => a?.distance - b?.distance));
            } else if(tabValue === 1) {
                const tempData = data.filter(store => store?.categoryType?.includes('BEDDING'));
                setEboStores(tempData.filter(store => store?.storeType === 'EBO').sort((a, b) => a?.distance - b?.distance));
                setMboStores(tempData.filter(store => store?.storeType === 'MBO').sort((a, b) => a?.distance - b?.distance));
            }
        }
    }, [tabValue, data]);

  return (
    <div className='bs-search-results'>
        <div className='bs-search-results__title-wrap'>
            <label className='bs-search-results__title'>Search results</label>
            {centerChangedFlag ? <button className='bs-search-results__icon-link' onClick={() => onPlaceSelect('')}><span className='icon icon-reset bs-search-results__icon'></span><span className='bs-search-results__title'>Reset</span></button> : null}
        </div>
        <div className='bs-search-results__tab-wrap'>
            <div className="bs-tabs bs-search-results__tabs">
                <div className="bs-tabs__nav-wrap bs-search-results__tab-nav-wrap">
                    <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example" className="bs-tabs__nav">
                        <Tab
                            label={<div className="bs-tabs__nav-text bs-search-results__tab-nav-text">fabric stores</div>}
                            {...a11yProps(0)}
                            className="bs-tabs__nav-item bs-search-results__tab-nav-item"
                        />
                        <Tab
                            label={<div className="bs-tabs__nav-text bs-search-results__tab-nav-text">bedding stores</div>}
                            {...a11yProps(1)}
                            className="bs-tabs__nav-item bs-search-results__tab-nav-item"
                        />
                    </Tabs>
                </div>
                <div className="bs-tabs__cont bs-search-results__tab-cont">
                    <CustomTabPanel value={tabValue} index={0} className="bs-tabs__tab-panel">
                        <ul className='bs-search-results__list-wrap'>
                            {eboStores.map((item, index) => {
                                return (
                                    <li className='bs-search-results__list-item' key={index}>
                                        <div className='bs-search-results__item'>
                                            {index === 0 ? (<h3 className='bs-search-results__item-title bs-search-results__item-title--section'>{'exclusive stores'}</h3>) : null}
                                            <h4 className='bs-search-results__item-title'>{item.storeName}</h4>
                                            <ul className='bs-search-results__item-tag-list'>
                                                {item?.categoryType.split(',').map((tag, tagIndex) => (
                                                    <li className='bs-search-results__item-tag-item' key={tagIndex}>
                                                        <ProductTag title={tag} classname="bs-search-results__item-tag" />
                                                    </li>
                                                ))}
                                                {/* <li className='bs-search-results__item-tag-item'>
                                                    <ProductTag title={`Fabric`} classname="bs-search-results__item-tag" />
                                                </li>
                                                <li className='bs-search-results__item-tag-item'>
                                                    <ProductTag title={`Bedding`} classname="bs-search-results__item-tag" />
                                                </li> */}
                                            </ul>
                                            <address className='bs-search-results__item-address'>{`${item.fullAddress} ${item.city} ${item.state} ${item.pinCode}`}</address>
                                            <ul className='bs-search-results__item-action-wrap'>
                                                <li className='bs-search-results__item-action-item'>
                                                    <a href={item.googleMapLink} target="_blank" className='bs-info-window__item-direction' rel="noreferrer">
                                                        <span className="icon icon-direction bs-info-window__icon"></span>
                                                        <span className="bs-info-window__text">Directions</span>
                                                    </a>
                                                </li>
                                                <li className='bs-search-results__item-action-item'>
                                                    <a href={`tel:${item.contactNumber}`} className='bs-info-window__item-direction'>
                                                        <span className="icon icon-call bs-info-window__icon"></span>
                                                        <span className="bs-info-window__text">{item.contactNumber}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                )
                            })}
                            {mboStores.map((item, index) => {
                                return (
                                    <li className='bs-search-results__list-item' key={index}>
                                        <div className='bs-search-results__item'>
                                            <h4 className='bs-search-results__item-title'>{item.storeName}</h4>
                                            <ul className='bs-search-results__item-tag-list'>
                                                {item?.categoryType.split(',').map((tag, tagIndex) => (
                                                    <li className='bs-search-results__item-tag-item' key={tagIndex}>
                                                        <ProductTag title={tag} classname="bs-search-results__item-tag" />
                                                    </li>
                                                ))}
                                                {/* <li className='bs-search-results__item-tag-item'>
                                                    <ProductTag title={`Fabric`} classname="bs-search-results__item-tag" />
                                                </li>
                                                <li className='bs-search-results__item-tag-item'>
                                                    <ProductTag title={`Bedding`} classname="bs-search-results__item-tag" />
                                                </li> */}
                                            </ul>
                                            <address className='bs-search-results__item-address'>{`${item.fullAddress} ${item.city} ${item.state} ${item.pinCode}`}</address>
                                            <ul className='bs-search-results__item-action-wrap'>
                                                <li className='bs-search-results__item-action-item'>
                                                    <a href={item.googleMapLink} target="_blank" className='bs-info-window__item-direction' rel="noreferrer">
                                                        <span className="icon icon-direction bs-info-window__icon"></span>
                                                        <span className="bs-info-window__text">Directions</span>
                                                    </a>
                                                </li>
                                                <li className='bs-search-results__item-action-item'>
                                                    <a href={`tel:${item.contactNumber}`} className='bs-info-window__item-direction'>
                                                        <span className="icon icon-call bs-info-window__icon"></span>
                                                        <span className="bs-info-window__text">{item.contactNumber}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={1} className="bs-tabs__tab-panel">
                        <ul className='bs-search-results__list-wrap'>
                            {eboStores.map((item, index) => {
                                return (
                                    <li className='bs-search-results__list-item' key={index}>
                                        <div className='bs-search-results__item'>
                                            {index === 0 ? (<h3 className='bs-search-results__item-title bs-search-results__item-title--section'>{'exclusive stores'}</h3>) : null}
                                            <h4 className='bs-search-results__item-title'>{item.storeName}</h4>
                                            <ul className='bs-search-results__item-tag-list'>
                                                {item?.categoryType.split(',').map((tag, tagIndex) => (
                                                    <li className='bs-search-results__item-tag-item' key={tagIndex}>
                                                        <ProductTag title={tag} classname="bs-search-results__item-tag" />
                                                    </li>
                                                ))}
                                                {/* <li className='bs-search-results__item-tag-item'>
                                                    <ProductTag title={`Fabric`} classname="bs-search-results__item-tag" />
                                                </li>
                                                <li className='bs-search-results__item-tag-item'>
                                                    <ProductTag title={`Bedding`} classname="bs-search-results__item-tag" />
                                                </li> */}
                                            </ul>
                                            <address className='bs-search-results__item-address'>{`${item.fullAddress} ${item.city} ${item.state} ${item.pinCode}`}</address>
                                            <ul className='bs-search-results__item-action-wrap'>
                                                <li className='bs-search-results__item-action-item'>
                                                    <a href={item.googleMapLink} target="_blank" className='bs-info-window__item-direction' rel="noreferrer">
                                                        <span className="icon icon-direction bs-info-window__icon"></span>
                                                        <span className="bs-info-window__text">Directions</span>
                                                    </a>
                                                </li>
                                                <li className='bs-search-results__item-action-item'>
                                                    <a href={`tel:${item.contactNumber}`} className='bs-info-window__item-direction'>
                                                        <span className="icon icon-call bs-info-window__icon"></span>
                                                        <span className="bs-info-window__text">{item.contactNumber}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                )
                            })}
                            {mboStores.map((item, index) => {
                                return (
                                    <li className='bs-search-results__list-item' key={index}>
                                        <div className='bs-search-results__item'>
                                            <h4 className='bs-search-results__item-title'>{item.storeName}</h4>
                                            <ul className='bs-search-results__item-tag-list'>
                                                {item?.categoryType.split(',').map((tag, tagIndex) => (
                                                    <li className='bs-search-results__item-tag-item' key={tagIndex}>
                                                        <ProductTag title={tag} classname="bs-search-results__item-tag" />
                                                    </li>
                                                ))}
                                                {/* <li className='bs-search-results__item-tag-item'>
                                                    <ProductTag title={`Fabric`} classname="bs-search-results__item-tag" />
                                                </li>
                                                <li className='bs-search-results__item-tag-item'>
                                                    <ProductTag title={`Bedding`} classname="bs-search-results__item-tag" />
                                                </li> */}
                                            </ul>
                                            <address className='bs-search-results__item-address'>{`${item.fullAddress} ${item.city} ${item.state} ${item.pinCode}`}</address>
                                            <ul className='bs-search-results__item-action-wrap'>
                                                <li className='bs-search-results__item-action-item'>
                                                    <a href={item.googleMapLink} target="_blank" className='bs-info-window__item-direction' rel="noreferrer">
                                                        <span className="icon icon-direction bs-info-window__icon"></span>
                                                        <span className="bs-info-window__text">Directions</span>
                                                    </a>
                                                </li>
                                                <li className='bs-search-results__item-action-item'>
                                                    <a href={`tel:${item.contactNumber}`} className='bs-info-window__item-direction'>
                                                        <span className="icon icon-call bs-info-window__icon"></span>
                                                        <span className="bs-info-window__text">{item.contactNumber}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    </CustomTabPanel>
                </div>
            </div>
        </div>
        
    </div>
  )
}

export default SearchResult